<div class="bg-gray-50 rounded-xl ca-shadow h-full flex flex-col">
  <h2 class="p-2 text-base font-bold text-gray-700 m-0">{{ title }}</h2>
  <div class="mt-2 p-2 h-full justify-center flex align-middle" *ngIf="average === null || type === 'duration-ms' && (average | msToReadableDuration).value === Infinity; else comparisonCard" >
    <h5>Not enough data</h5>
    </div>
    <ng-template #comparisonCard>

  <div class="mt-4 p-2 h-full justify-between flex flex-col" *ngIf="average !== null">
    <div class="grow flex flex-col justify-start align-middle">
      <div class="text-6xl font-bold text-center">
        <div *ngIf="type === 'duration-ms'; else defaultAverage">
          {{(average | msToReadableDuration).value}} 
            <div class="text-base">{{(average | msToReadableDuration).unit | translate}}</div>
          </div>
          <ng-template #defaultAverage>
            {{ average | number : "1.0-1" }}
            <div *ngIf="!!typeTranslation" class="text-base">{{typeTranslation + (average === 1 ? '' : 's') | translate}}</div>
        </ng-template>
      </div>
      <div *ngIf="!!subtitle" class="text-center p-5"
      >
        {{subtitle}}
      </div>
      <ng-container *ngIf="!subtitle">
      
      <div
        *ngIf="average === previousAverage"
        class="flex align-middle justify-center items-center h-6"
      >
        <p class="text-sm font-bold text-center text-gray-600">No Change</p>
      </div>
      <div
        *ngIf="average > previousAverage && previousAverage === 0"
        class="flex align-middle justify-center items-center h-6"
      >
        <p class="text-sm font-bold text-center text-gray-600">Previously 0</p>
      </div>
      <div
        *ngIf="average > previousAverage && previousAverage !== 0"
        class="flex align-middle justify-center items-center h-6"
      >
        <mat-icon
          [class]="
            fewerIsPreferred === true ? 'text-red-800' : 'text-green-600'
          "
          >arrow_upward</mat-icon
        >
        <p
          *ngIf="average > 0"
          [class]="
            'text-sm font-bold text-center ' +
            (fewerIsPreferred === true ? 'text-red-800' : 'text-green-600')
          "
        >
          {{
            ((average - previousAverage) / previousAverage) * 100
              | number : "1.0-0"
          }}%
        </p>
      </div>
      <div
        *ngIf="average < previousAverage"
        class="flex align-middle justify-center items-center h-6"
      >
        <mat-icon
          [class]="
            fewerIsPreferred === true ? 'text-green-600' : 'text-red-800'
          "
          >arrow_downward</mat-icon
        >
        <p
          [class]="
            'text-sm font-bold text-center ' +
            (fewerIsPreferred === true ? 'text-green-600' : 'text-red-800')
          "
        >
          {{
            ((previousAverage - average) / previousAverage) * 100
              | number : "1.0-0"
          }}%
        </p>
      </div>
    </ng-container>
    </div>
    <ng-container *ngIf="!!best && !!worst">
      <div class="flex flex-row justify-between mt-4">
        <div class="flex flex-column">
          <p class="text-sm font-bold text-center text-green-600">
            <ng-container *ngIf="type === 'duration-ms'; else defaultBest">
              Best:
              {{(best | msToReadableDuration).value}} 
              {{(best | msToReadableDuration).unit | translate}}
            </ng-container>
            <ng-template #defaultBest>
              Best: {{ best | number : "1.0-0" }}
            </ng-template>          
          </p>
        </div>
        <div class="flex flex-column">
          <p class="text-sm font-bold text-center text-red-800">
            <ng-container *ngIf="type === 'duration-ms'; else defaultWorst">
              Worst:
              {{(worst | msToReadableDuration).value}} 
              {{(worst | msToReadableDuration).unit | translate}}
            </ng-container>
            <ng-template #defaultWorst>
              Worst: {{ worst | number : "1.0-0" }}
            </ng-template>       
          </p>
        </div>
      </div>
    </ng-container>
    </div>
  </ng-template>
</div>
